import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { openModal } from '../../features/modal/modalSlice'

export default function PopButton({
  children,
  className = '',
  style=''
}) {

  const dispatch = useDispatch();
  const location = useLocation();

  return (
    <div
      onClick={() => dispatch(openModal())}
      className={`cursor-pointer inline-flex items-center justify-center rounded-[10px] px-3 text-[12.2px] font-medium text-black transition-all duration-300 hover:scale-105 hover:shadow-lg
      ${
        location.pathname === "/solutions"
          ? "py-3"
          : "py-2"
      }
      ${className}`}
    >
      {children}
    </div>
  );
}

// export default function PopButtontwo({
//   children,
//   className = '',
//   style=''
// }) {
//     const dispatch = useDispatch();

//   return (
//     <div onClick={() => dispatch(openModal())} className={`cursor-pointer inline-flex items-center justify-center rounded-[10px] px-3 py-2 text-[12.2px] font-medium text-black transition-all duration-300 hover:scale-105 hover:shadow-lg ${className}`}>
//       {children}
//     </div>
//   );
// }